import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import { Form, Formik, FormikContextType } from "formik";
import { FormControl } from "../form-control";
import Button from "../button";
import Input from "../input";
import { createRef } from "react";
import useObservable from "@core/hooks/use-observable.hook";
import { createAccountSchemaValidation } from "@app/validations";
import { CreateAccount } from "@app/types";
import AccountService from "@app/services/http/account.service";

function CreateAccountModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps) {
  const formRef = createRef<FormikContextType<CreateAccount>>();

  const { subscribeUntilDestroy } = useObservable();

  const initialValues: CreateAccount = {
    taiKhoan: portalData?.account?.username || "",
    matKhau: "",
    name: portalData?.account?.name || "",
  };

  const handleSubmit = (values: CreateAccount) => {
    if (!portalData?.account) {
      subscribeUntilDestroy(AccountService.createAccount(values), (account) => {
        portalDialogRef.close({ account });
      });
    } else {
      subscribeUntilDestroy(
        AccountService.updatedAccount(portalData.account._id, values),
        (account) => {
          portalDialogRef.close({ account });
        }
      );
    }
  };

  return (
    <Modal onCancel={portalDialogRef.close} buttonCancelInChildren>
      <div className="w-[500px] sm:w-[500px] p-5">
        <div className="font-bold text-xl">Tạo tài khoản công ty</div>
        <Formik
          initialValues={initialValues}
          validationSchema={createAccountSchemaValidation}
          innerRef={formRef}
          onSubmit={handleSubmit}
          validateOnChange
          validateOnBlur
        >
          <Form>
            <div className="flex justify-between gap-5">
              <div className="flex-1">
                <div className="mt-3 flex-1">
                  <FormControl name="name">
                    <Input
                      className="mt-1 !max-w-none text-sm"
                      errorClassName="text-sm"
                      placeholder="Nhập tên công ty"
                    />
                  </FormControl>
                </div>
                <div className="mt-3 flex-1">
                  <FormControl name="taiKhoan">
                    <Input
                      className="mt-1 !max-w-none text-sm"
                      errorClassName="text-sm"
                      placeholder="Nhập tài khoản"
                    />
                  </FormControl>
                </div>
                <div className="mt-3 flex-1">
                  <FormControl name="matKhau">
                    <Input
                      width="auto"
                      className="!max-w-none mb-[22px]"
                      inputClassName="!rounded !border-[#DCDFE6] h-[40px] leading-[40px] text-sm text-[#606266]"
                      placeholder="Nhập mật khẩu..."
                      inputElement={
                        <i className="fa fa-lock text-[#c0c4cc]"></i>
                      }
                      errorClassName="text-[#F56C6C] text-xs"
                    />
                  </FormControl>
                </div>
              </div>
            </div>
            <Button
              type="submit"
              label={portalData?.account ? "Cập nhật" : "Thêm"}
              containerClassName="mt-5 mx-auto"
              width="fit-content"
              className="px-6 text-sm"
              labelClassName="font-bold"
            />
          </Form>
        </Formik>
      </div>
    </Modal>
  );
}

export default CreateAccountModal;
